import { render, staticRenderFns } from "./SimpleViewLayout.vue?vue&type=template&id=3d096804&"
import script from "./SimpleViewLayout.vue?vue&type=script&lang=js&"
export * from "./SimpleViewLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports